export default "__VITE_ASSET__mlTT1PFh__"